import {
  section,
  container,
  image,
  content,
  titleText,
  descriptionText,
} from './Procedimento.styles';
import Result1 from '../../assets/results1.png';

export default function Procedimento() {
  return (
    <section className={section} id='procedimento'>
      <div className={container}>
        <img src={Result1} alt='Procedimento' className={image} />
        <div className={content}>
          <p className={titleText}>Perfiloplastia: Proporção e Harmonia</p>
          <p className={descriptionText}>
            A perfiloplastia é um conjunto de técnicas que equilibra o perfil
            facial, trazendo elegância e harmonia na medida certa.
          </p>
          <p className={descriptionText}>
            O tratamento atua em três pontos estratégicos: rinomodelação, lábios
            e mento, alinhando o perfil e revelando o contorno facial dos
            sonhos.
          </p>
          <p className={descriptionText}>
            O objetivo é valorizar a sua beleza de forma única e natural, sem
            alterar suas características, apenas realçando o que já é seu.
          </p>
        </div>
      </div>
    </section>
  );
}
